import { render } from "./AboutDeviceSection.vue?vue&type=template&id=3ea786aa"
import script from "./AboutDeviceSection.vue?vue&type=script&lang=js"
export * from "./AboutDeviceSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__